import { createAPI } from "../apisServer";
import BaseUrl from "../baseUrls";
import reqS3 from "../ai/reqS3";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqProduto = {
	listPaginate: async function (param, paramValue, active, page, tipoproduto, perpage = 15) {
		return apiServer
			.get("portal/v1/produto/paginate", {
				params: {
					param,
					paramValue,
					active,
					page,
					perpage,
					tipoproduto: tipoproduto ?? "pai",
				},
				headers: {
					banco: banco,
					page,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listProductsSZ: async function name() {
		return apiServer
			.get("portal/v1/produto/sz", {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listProductsHomeSZ: async function name() {
		return apiServer
			.get("portal/v1/produto/home/sz", {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listProductsSZId: async function name(id) {
		return apiServer
			.get(`portal/v1/produto/sz/${id}`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listID: async function (id) {
		return apiServer
			.get(`portal/v1/produto/${id}`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	insert: async function (data) {
		return apiServer
			.post("portal/v1/produto", data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	gerarGrade: async function (data) {
		return apiServer
			.post("portal/v1/produto/grade", data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	getGrade: async function (id_produto) {
		return apiServer
			.get(`portal/v1/produto/${id_produto}/grade`, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	atualizarGrade: async function (data) {
		return apiServer
			.put("portal/v1/produto/grade", data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listLowStock: async function (params) {
		return apiServer
			.get("portal/v1/produto/estoque-baixo", {
				params: params,
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listLowStockGrade: async function (params) {
		return apiServer
			.get("portal/v1/produto/estoque-baixo-grade", {
				params: params,
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	inserirComUploadS3: async function (formData) {
		return reqS3.uploadFoto(formData);
	},
};

export default reqProduto;
// inserirComUploadS3: function (api, formData) {
// 	return apiServer
// 		.post("portal/v1/produto/upload", formData, {
// 			headers: {
// 				// "Content-Type": "multipart/form-data",
// 				banco,
// 			},
// 		})
// 		.then((response) => {
// 			return response;
// 		})
// 		.catch((error) => {
// 			throw error;
// 		});
// },
